import { TRUSTEE_URL } from "helpers/constant";
import { callApi } from "Apis";

export async function trusteeList(data) {
  try {
    const response = await callApi({ url: TRUSTEE_URL.LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function addTrustee(data) {
  try {
    const response = await callApi({ url: TRUSTEE_URL.ADD, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function getTrusteeById(id) {
  try {
    const response = await callApi({ url: TRUSTEE_URL.GET(id), method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}
export async function updateTrustee(data) {
  try {
    const response = await callApi({ url: TRUSTEE_URL.UPDATE, body: data, method: "PUT" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function deleteTrusteeById(id) {
  try {
    const response = await callApi({ url: TRUSTEE_URL.DELETE(id), method: "DELETE" });
    return response;
  } catch (err) {
    throw err;
  }
}
